import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ModalBody from 'components/Utils/Modal/Body'
import ModalWrapper from 'components/Utils/Modal/Wrapper'
import { IncentiveModalContent } from './IncentiveModalContent'

export class IncentiveModal extends Component {
  static propTypes = {
    onModalClose: PropTypes.func.isRequired,
  }

  render() {
    return (
      <ModalWrapper
        preventClose
        size={400}
        onModalClose={this.props.onModalClose}
      >
        <ModalBody style={{ padding: 0 }}>
          <IncentiveModalContent closeModal={this.props.onModalClose} />
        </ModalBody>
      </ModalWrapper>
    )
  }
}

export default IncentiveModal
